const initailState = {
    arr:[],
    nextKey:''
}
const All_Riders=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_RIDERS':
            return{ 
                arr: state.arr.concat(action.payload),
                nextKey:action.keynext,
                TotalCount:action.counts

            }
        default:
            return state;
    }
}

export default All_Riders